// extracted by mini-css-extract-plugin
export var addToCartButton = "_ou-b";
export var arrowButtonContainer = "_ou-9";
export var arrowButtonIcon = "_ou-a";
export var carouselArrowButton = "_ou-6";
export var carouselElementContainer = "_ou-1";
export var galleryThumbnail = "_ou-d";
export var galleryThumbnailImage = "_ou-e";
export var left = "_ou-7";
export var productDisplayCarouselContainer = "_ou-0";
export var productTileContainer = "_ou-2";
export var productTileImage = "_ou-4";
export var productTileImageContainer = "_ou-3";
export var productTileTitle = "_ou-5";
export var right = "_ou-8";
export var sliderOverflow = "_ou-c";